import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  APPLICATION_STATUS_MODULE,
  APPLICATION_STATUS_MODULE_MAP,
} from './constants';
import { ApplicationStatusContent } from './ApplicationStatusContent';
import { APPLICATION_MODULE } from '..';
import { useGetApplicationToDoList } from '../../graphql';
import { Loading, Alert } from '../../../../components';
import { APPLICATION_STATUS_TYPE } from '../../../../utils';

export type ApplicationStatusProps = {
  applicationStatus: string;
  applicationNo: string;
  entryYear: string;
  refetchApplication: () => void;
  handleChangeApplicationActivated: (
    activatedModule: APPLICATION_MODULE,
  ) => void;
};

export const ApplicationStatus: React.FC<ApplicationStatusProps> = (
  props: ApplicationStatusProps,
) => {
  const { applicationId = '' } = useParams();
  const {
    applicationNo,
    applicationStatus,
    entryYear,
    handleChangeApplicationActivated,
    refetchApplication,
  } = props;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const displayApplicationProgress =
    applicationStatus !== APPLICATION_STATUS_TYPE.CREATED &&
    Boolean(applicationStatus);

  // route protect, for situation: after application submission,redirect to payment page
  useEffect(() => {
    if (!displayApplicationProgress && Boolean(applicationStatus)) {
      searchParams.delete('aphb');
      handleChangeApplicationActivated(APPLICATION_MODULE.PROGRAMME_CHOICES);
    }
  }, [applicationStatus]);

  const {
    applicationToDoList,
    remarks: returnRemarks,
    loading,
    error,
    refetch,
  } = useGetApplicationToDoList(applicationId, !displayApplicationProgress);

  const { visibleList } = applicationToDoList;

  const headBarParam = searchParams.get('aphb') ?? '';

  // may comes from condition meet redirect or user input
  const targetHeadBarParam = (
    Object.keys(APPLICATION_STATUS_MODULE) as Array<
      keyof typeof APPLICATION_STATUS_MODULE
    >
  ).find(key => APPLICATION_STATUS_MODULE[key] === headBarParam);

  // visible list is APPLICATION_TODO_LIST[]
  const hasValidHeadBarParam = visibleList.findIndex(
    item =>
      targetHeadBarParam !== undefined &&
      item === APPLICATION_STATUS_MODULE_MAP[targetHeadBarParam],
  );

  const filteredToDoList = Object.keys(APPLICATION_STATUS_MODULE).filter(key =>
    visibleList.includes(key),
  );

  const defaultActivatedId =
    APPLICATION_STATUS_MODULE[
      filteredToDoList[
        filteredToDoList.length - 1
      ] as keyof typeof APPLICATION_STATUS_MODULE
    ] ?? APPLICATION_STATUS_MODULE.APPLICATION_FEE_PAYMENT;

  // aphb means Application HeadBar
  const sidebarActivated =
    hasValidHeadBarParam >= 0 && targetHeadBarParam !== undefined
      ? APPLICATION_STATUS_MODULE[targetHeadBarParam]
      : defaultActivatedId;

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <ApplicationStatusContent
          applicationNo={applicationNo}
          applicationToDoList={applicationToDoList}
          returnRemarks={returnRemarks}
          entryYear={entryYear}
          defaultSidebarActivated={sidebarActivated}
          refetch={refetch}
          refetchApplication={refetchApplication}
          handleChangeApplicationActivated={handleChangeApplicationActivated}
        />
      )}
    </div>
  );
};
